import React from 'react'

export default (props) => {
	const {
		imageUrl,
		titleId,
		titleName,
	} = props

	if (!imageUrl) {
		return null
	}

	const handleLinkClick = (event) => {
		event.preventDefault()

		props.showTitleCard(titleId)
	}

	return (
		<div className="cover" onClick={handleLinkClick}>
			<div className="cover__placeholder">
				<div className="cover__title">{titleName}</div>
			</div>
			<img className="cover__image" alt="" src={imageUrl} />
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/mobile/components/cover/index.js